import { RootState } from "@/store/store";
import { findFilterProviderInTree } from "@/components/pages/common/filters-tree/utils/helpers/findFilterProviderInTree";
import { ResourceExplorerFilterProvider } from "@/services/cloudchipr.api";
import { FilterGroupNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { isTreeNodeWithIdFilterGroup } from "@/components/pages/common/filters-tree/utils/helpers/isTreeNodeWithIdFilterGroup";
import { resourceExplorerPayloadDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resource-explorer-widget/resourceExplorerPayloadDataSelector";
import { addFilterTreePathToResourceExplorerPayload } from "@/store/resource-explorer/utils/helpers/path/addFilterTreePathToResourceExplorerPayload";
import { resourceExplorerPathLastItemFilterTreeSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/path/resourceExplorerPathLastItemFilterTreeSelector";

export const billingExplorerFilterTreeProvidersSelector = (
  state: RootState,
): ResourceExplorerFilterProvider[] | undefined => {
  const payload = resourceExplorerPayloadDataSelector(state);
  const pathLastItemFilterTree =
    resourceExplorerPathLastItemFilterTreeSelector(state);

  const resourceExplorerFilterSchema = pathLastItemFilterTree
    ? addFilterTreePathToResourceExplorerPayload(
        payload,
        pathLastItemFilterTree,
      )
    : payload;
  const filterTree =
    resourceExplorerFilterSchema?.filter_tree as FilterGroupNodeWithId;
  const scopeFilterTree =
    resourceExplorerFilterSchema?.scope_filter_tree as FilterGroupNodeWithId;

  const scopeFilterTreeLocal = scopeFilterTree ? [scopeFilterTree] : [];
  const scopeFiltersProviders = scopeFilterTreeLocal.reduce((result, item) => {
    if (!isTreeNodeWithIdFilterGroup(item)) {
      return result;
    }
    const items = item.items ?? [];
    const provider = findFilterProviderInTree(items);

    if (provider && !result.includes(provider)) {
      result.push(provider);
    }
    return result;
  }, [] as ResourceExplorerFilterProvider[]);

  if (scopeFiltersProviders.length) {
    return scopeFiltersProviders;
  }
  return filterTree?.items.reduce((result, item) => {
    if (!isTreeNodeWithIdFilterGroup(item)) {
      return result;
    }
    const provider = findFilterProviderInTree(item.items);

    if (provider && !result.includes(provider)) {
      result.push(provider);
    }
    return result;
  }, [] as ResourceExplorerFilterProvider[]);
};
